import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class ProductShippingStatus extends Component {
  connectedCallback() {
    super.connectedCallback();

    const closestSection = this.closest('.shopify-section, dialog');

    closestSection?.addEventListener(
      StandardEvents.productSelect,
      this.#handleProductSelect
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    const closestSection = this.closest('.shopify-section, dialog');

    closestSection?.removeEventListener(
      StandardEvents.productSelect,
      this.#handleProductSelect
    );
  }

  #handleProductSelect = (event) => {
    if (
      !(event.target instanceof Element) ||
      event.target.closest('product-card')
    ) {
      return;
    }

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (
          detail.productId &&
          detail.productId !== this.dataset.productId
        ) {
          return;
        }

        const newStatus = html.querySelector(
          `product-shipping-status[data-block-id="${this.dataset.blockId}"]`
        );

        if (!newStatus) return;

        morph(this, newStatus, {
          childrenOnly: true,
        });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.warn(
            '[product-shipping-status] Event promise rejected:',
            error
          );
        }
      });
  };
}

if (!customElements.get('product-shipping-status')) {
  customElements.define(
    'product-shipping-status',
    ProductShippingStatus
  );
}
